import { css } from 'styled-components'

const boxShadowHover = () => css`
  position: relative;
  
  &::before {
    box-shadow: 0 4px 2px rgba(0, 0, 0, 1.0);
    content: ' ';
    opacity: 0.1;
    pointer-events: none;
    position: absolute;
    transition: opacity 250ms;
    
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  &:hover::before {
    opacity: 0.25;
  }
`

export { boxShadowHover }
